import { ProcessMessage, StatefulMessage } from './useProcessMessage'
import { DriveItem } from '@microsoft/microsoft-graph-types'
import useDocumentGenerationHandler, { DocumentGenerationStatusData } from '../document/useDocumentGenerationHandler'
import { QueueStatus } from '../useQueueStateHandler'

export type DocumentNotificationData = StatefulMessage<{
    messageId: string // The original service bus message ID.
    driveItem: DriveItem
}>

export type DocumentNotification = ProcessMessage<DocumentNotificationData>

export default function useProcessDocumentNotification() {
    const handler = useDocumentGenerationHandler<DocumentNotificationData, DocumentGenerationStatusData>()
    return (notification: DocumentNotification) => {
        handler.transition(notification.data.state, QueueStatus.Finished, {
            messageId: notification.data.messageId,
            driveItem: notification.data.driveItem,
        })
    }
}
